<template>
  <Loader v-if="loader" />

  <div id="mind-tab"> 
    <CambioRappresentanteDialog
      v-model="cambioRappresentanteVisible"
      :available="cambioRappresentanteAvailable === true"
      :clienti="clientiCambioRappresentante"
      :contratti="contrattiCambioRappresentante"
      @saved="onCambioRappresentanteSaved"
      @created="onCambioRappresentanteSaved"
    />
    <CreaRappresentanteDialog
      v-model="creaRappresentanteVisible"
      :available="cambioRappresentanteAvailable === true"
      :initialIdentifier="creaRappresentanteIdentifier"
      @created="onCambioRappresentanteSaved"
    />
    <accordion class="box-operation-mtab">
      <accordion-tab>
        <template #header>
          <i class="pi pi-plus-circle"> </i>
          <span class="pl-1">Operazioni</span>
        </template>      
        <span v-for="button in selectedTabs[activeTabIndex].buttons" :key="button.key">
          <span v-if="isButtonVisible(button)">
            <FileUpload v-if="button.upload" :auto="true" :class="button.classCss" class="m-1" mode="basic" name="file" ref="file" :accept="button.accept" customUpload @uploader="callDynamicButtonMethod(button.method)" :chooseLabel="button.label" :chooseIcon="button.icon" iconPos="right"/>
            <prime-button v-else-if="button.method != ''" :label="buttonLabel(button)" :icon="button.icon" :class="button.classCss" iconPos="right" class="m-1" @click="callDynamicButtonMethod(button.method)"/>
          </span>
        </span>   
      </accordion-tab>
    </accordion>

    <accordion class="box-filter-mtab" >
      <accordion-tab>
        <template #header>
          <i class="pi pi-filter"></i>&nbsp;
          <span>Filtri <span class="num-filtri"> {{flatTableFilters.length}}</span> </span>
        </template>

        <div class="filter-wrap p-d-flex p-flex-wrap p-ai-center p-flex-sm-row">
          <div v-if="flatTableFilters.length"  @click="cleanAllFilters" class="clean-filters">
            Pulisci tutto<i class="pi pi-ban"></i> 
          </div>
            <chip 
              v-for="(element, key) in flatTableFilters"
              :key="element"
              class="filter-chip" 
              @remove="onFilterItemRemove({key, element})" 
              removable
            > 
              <!-- <i class="pi pi-tag"></i>&nbsp; -->
              {{ `${element.table} - ${element.label}` }}
            </chip>
        </div>

      </accordion-tab>
    </accordion>

    <!-- <div v-if="user.id == 42">
      <h3><img src="@/assets/img/pico-mark-light-UDJTJFFW.png" alt="" style="width: 21px; aspect-ratio: 1;">Che Chic <img src="@/assets/img/pico-mark-light-UDJTJFFW.png" alt="" style="width: 21px; aspect-ratio: 1;"></h3>
    </div> -->

    <div class="wrapper-mindtab">
    <multi-select 
      v-model="selectedTabs" 
      :options="tabs" 
      optionLabel="label" 
      placeholder="" 
      :filter="true" 
      id="multiselect-tabs"
    >
    <i class="pi pi-check"></i>
    </multi-select>

    <tab-view v-model:activeIndex="activeTabIndex" scrollable>
      <tab-panel v-for="(tab) in selectedTabs" :key="tab.label">
        <template v-if="tab" #header>
          <i class="icon-tab" v-if="tab.icon" :class="tab.icon"></i>
          <span class="dynamic-font-size">{{ tab.label }}</span>
          <span class="num-tab">{{ tab.rows }}</span>
        </template>
        <keep-alive>
          <component v-if="tab" :is="tab.component" :intialActiveTabs="activeTabList" :initialFilters="filter"
            @row-fetched="tab.onRowFetched" @row-selected="tab.onRowSelected" @row-filtered="tab.onRowFiltered"
            @data-searching="tab.onDataSearching" @representative-search-input="representativeSearchText = $event"></component>
        </keep-alive>
      </tab-panel>
    </tab-view>
  </div> </div> 

</template>
<script>
/* eslint-disable vue/no-unused-components */

import { reactive } from 'vue'
import { debounce } from 'underscore'
import { getCurrentInstance } from 'vue';

import PrimeButton from 'primevue/button';
import listOfTabs from '@/config/mind-tab/tabs'
import ClientiDataTable from '@/components/ask/tables/ClientiDataTable.vue'
import CambioRappresentanteDialog from '@/components/ask/details/CambioRappresentanteDialog.vue'
import CreaRappresentanteDialog from '@/components/ask/details/CreaRappresentanteDialog.vue'
import CambioRappresentanteService from '@/services/ask-pratiche/cambio-rappresentante'
import FattureClientiDataTable from '@/components/ask/tables/FattureClientiDataTable.vue'
// import FattureAcquistoDataTable from '@/components/ask/tables/FattureAcquistoDataTable.vue'
// import FornitoriDataTable from '@/components/ask/tables/FornitoriDataTable.vue'
import ContrattiVenditaDataTable from '@/components/ask/tables/ContrattiVenditaDataTable.vue'
import ListiniDataTable from '@/components/ask/tables/ListiniDataTable.vue'
import PodsDataTable from '@/components/ask/tables/PodsDataTable.vue'
import PdrsDataTable from '@/components/ask/tables/PdrsDataTable.vue'
import RappresentantiDataTable from '@/components/ask/tables/RappresentantiDataTable.vue'
import AgentiDataTable from '@/components/ask/tables/AgentiDataTable.vue'
import AgentiFirmatariDataTable from '@/components/ask/tables/AgentiFirmatariDataTable.vue'
import Loader from "@/components/Loader.vue";

export default {
  name: 'MindTab',

  components: {
    PrimeButton,
    Loader,
    ClientiDataTable,
    CambioRappresentanteDialog,
    CreaRappresentanteDialog,
    FattureClientiDataTable,
    // FattureAcquistoDataTable,
    // FornitoriDataTable,
    ContrattiVenditaDataTable,
    ListiniDataTable,
    PodsDataTable,
    PdrsDataTable,
    RappresentantiDataTable,
    AgentiDataTable,
    AgentiFirmatariDataTable
  },

  data() {
    return {
      pageName: 'Ask',
      self: getCurrentInstance(),

      emitFilterChanged: true,

      selectedRowsByTable: {},

      filtered: {
        items: {},
        ids: {},
      },

      filter: {
        searches: {},
        items: {}
      },
      tableFilters: {},

      tabs: [],
      activeTabIndex: 0,
      selectedTabs: [],
      user: JSON.parse(atob(localStorage.getItem('user'))).user[0],
      loader: false,
      cambioRappresentanteVisible: false,
      creaRappresentanteVisible: false,
      creaRappresentanteIdentifier: '',
      representativeSearchText: null,
      cambioRappresentanteAvailable: null,
      clientiCambioRappresentante: [],
      contrattiCambioRappresentante: []
    }
  },

  created() {
    const allTabs = listOfTabs.map((el) => {

      const newEl = reactive({ ...el })

      newEl.rows = 0

      const onRowFetchedMethod = function (evt) {
        this.rows = evt.rows
      }

      const onRowSelectedMethod = function (evt) {
        let el = {}
        el[evt.source] = evt.items

        this.selectedRowsByTable = { ...this.selectedRowsByTable, ...el }
      }

      const onRowFilteredMethod = function (evt) {

        let el = {}
        el[evt.filter.key] = evt.filter.items.map((element) => {
          return {
            key: evt.filter.key,
            source: evt.filter.source,
            property: element.key,
            value: element.value,
            label: element.label,
          }
        })
        this.filter.items = { ...this.filter.items, ...el }

        el = {}
        el[evt.filter.source] = evt.filter.items.map((element) => element.item)
        this.filtered.items = { ...this.filtered.items, ...el }

        el = {}
        el[evt.filter.source] = evt.filter.items.map((element) => {
          return {
            key: evt.filter.key,
            property: element.key,
            value: element.value,
          }
        })
        this.filtered.ids = { ...this.filtered.ids, ...el }
      }

      const onDataSearchingMethod = function (evt) {
        let el = {}
        const items = { ...evt.filter.items }

        items.source = evt.filter.source
        el[evt.filter.target] = items

        this.filter.searches = { ...this.filter.searches, ...el }
      }

      newEl.onRowFetched = onRowFetchedMethod.bind(newEl)
      newEl.onRowSelected = onRowSelectedMethod.bind(this)
      newEl.onRowFiltered = onRowFilteredMethod.bind(this)
      newEl.onDataSearching = onDataSearchingMethod.bind(this)

      if ('buttons' in newEl && Object.keys(newEl.buttons).length != 0) {
        newEl.buttons = newEl.buttons.map((button) => {
          button.filter = newEl.name
          return button
        })
      }

      return newEl
    })

    const activeTabs = allTabs.filter((el) => el.default)

    activeTabs.forEach((el) => { delete el.default })
    allTabs.forEach((el) => { delete el.default })

    this.selectedTabs = activeTabs
    this.tabs = allTabs
  },

  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
    this.loadCambioRappresentanteAvailability()
  },

  methods: {
    async loadCambioRappresentanteAvailability() {
      try {
        this.cambioRappresentanteAvailable = await new CambioRappresentanteService(this.$http).isAvailable()
      } catch (error) {
        this.cambioRappresentanteAvailable = null
      }
      if (this.cambioRappresentanteAvailable !== null && this.$route.query.creaRappresentante === '1') {
        this.creaRappresentanteVisible = true
        const query = { ...this.$route.query }
        delete query.creaRappresentante
        this.$router.replace({ query })
      }
    },
    async openCambioRappresentante() {
      if (!this.canOpenCambioRappresentante) return
      if (this.clientiFiltrati.length === 0) {
        this.clientiCambioRappresentante = []
        this.contrattiCambioRappresentante = []
        this.cambioRappresentanteVisible = true
        return
      }
      this.loader = true
      try {
        const { clienti, contratti } = await new CambioRappresentanteService(this.$http)
          .preview(this.clientiFiltrati.map(cliente => Number(cliente.id)))
        if (clienti.some(cliente => !cliente?.id || Number(cliente.cod_type_client) === 2 || cliente.cod_type_client == null)) {
          throw new Error('La selezione contiene un cliente non valido o domestico.')
        }
        this.clientiCambioRappresentante = clienti.map(cliente => ({
          id: cliente.id,
          cod_type_client: cliente.cod_type_client,
          cod_rapp: cliente.cod_rapp,
          codfis: cliente.codfis,
          piva: cliente.piva,
          nome: cliente.ragsoc || String(cliente.id)
        }))
        const names = new Map(this.clientiCambioRappresentante.map(cliente => [String(cliente.id), cliente.nome]))
        this.contrattiCambioRappresentante = contratti.map(contratto => ({
          ...contratto,
          label: Number(contratto.active) === 1 ? 'attivo' : 'non attivo',
          nome_cliente: names.get(String(contratto.cod_cliente))
        }))
        this.cambioRappresentanteVisible = true
      } catch (error) {
        this.$eventBus.emit('data-load-error', { message: error.message || 'Impossibile caricare i clienti selezionati.' })
      } finally {
        this.loader = false
      }
    },
    async openCreaRappresentante() {
      if (this.cambioRappresentanteAvailable === null) await this.loadCambioRappresentanteAvailability()
      if (this.cambioRappresentanteAvailable === null) {
        this.$eventBus.emit('data-load-error', { message: 'Impossibile verificare la disponibilità del salvataggio documenti.' })
        return
      }
      this.creaRappresentanteIdentifier = this.representativeSearchIdentifier
      this.creaRappresentanteVisible = true
    },
    buttonLabel(button) {
      return button.key === 'rappresentanti-button-aggiungi' && this.representativeSearchIdentifier
        ? `${button.label} ${this.representativeSearchIdentifier}` : button.label
    },
    onCambioRappresentanteSaved() {
      const items = Object.fromEntries(Object.entries(this.filter.items).map(([key, values]) => [key, values.map(item => item.value)]))
      this.$eventBus.emit('data-filter-changed', { target: this, filter: { items, searches: this.filter.searches } })
    },
    toggleFilterVisibility() {
      this.filtersVisible = !this.filtersVisible;
    },
    onFilterItemRemove(evt) {
      if (Object.keys(this.filter.items).length > 1 || this.filter.items[evt.element.source].length > 1) {
        this.filter.items[evt.element.source].splice(this.filter.items[evt.element.source].findIndex((e) => e.label === evt.element.label), 1)
      } else {
        this.cleanAllFilters()
      }
      if (!this.filter.items[evt.element.source].length) {
        delete this.filter.items[evt.element.source]
      }
    },

    cleanAllFilters() {
      this.filter.items = {}
      this.$eventBus.emit('data-all-filter-clean', this.filter.items)
    },

    isButtonVisible(button) {
      switch (button.display) {
        case 'always':
          return true;

        case 'on-data-selected': {
          const properties = Object.keys(this.selectedRowsByTable).filter((k) => k == button.filter)
          if (properties.length > 0) {
            if (this.selectedRowsByTable[button.filter]) {
              return this.selectedRowsByTable[button.filter].length > 0
            }
          }
          return false
        }

        case 'on-data-filtered': {
          const properties = Object.keys(this.filtered.ids).filter((k) => k == button.filter)
          if (properties.length > 0) {
            if (this.filtered.ids[button.filter]) {
              return this.filtered.ids[button.filter].length > 0
            }
          }
          return false
        }

        case 'on-non-domestic-clients-filtered':
          return this.canOpenCambioRappresentante

        default:
          return false;
      }
    },

    callDynamicButtonMethod(methodMetadata) {
      if (typeof methodMetadata != 'string') {
        if (typeof methodMetadata.method === 'function') {
          if (methodMetadata.bindTo) {
            switch (methodMetadata.bindTo) {
              case false:
                return methodMetadata.method.apply(null, [])

              case 'this':
                if (methodMetadata.uploadFile) {
                  this.loader = true
                  Promise.all([
                    methodMetadata.method.apply(this, [this.self.refs.file.files[0]])
                  ]).finally(()=>{
                    this.loader = false
                  })
                  this.self.refs.file.files = null;
                  return
                }
                return methodMetadata.method.apply(this, [])

              default:
                return
            }
          }

          return methodMetadata.method.apply(null, [])
        }
      }

      return
    },
  },

  computed: {
    canOpenCambioRappresentante() {
      if (!this.cambioRappresentanteAvailable) return false
      const clientFilters = this.flatTableFilters.filter(item => item.table === 'CLIENTI')
      return this.flatTableFilters.every(item => item.table === 'CLIENTI' || item.table === 'RAPPRESENTANTI')
        && clientFilters.length === this.clientiFiltrati.length
        && this.clientiFiltrati.every(cliente => Number(cliente.cod_type_client) !== 2 && cliente.cod_type_client != null)
    },
    representativeSearchIdentifier() {
      const searchText = this.representativeSearchText === null
        ? this.filter.searches.rappresentantiDataTable?.search : this.representativeSearchText
      const value = String(searchText || '').trim().toUpperCase()
      const valid = /^[A-Z0-9]{16}$/.test(value) || /^\d{11}$/.test(value)
      return valid ? value : ''
    },
    clientiFiltrati() {
      const ids = new Set((this.filter.items['cliente.ids'] || []).map(item => String(item.value)))
      return (this.filtered.items.clientiDataTable || []).filter(cliente => ids.has(String(cliente.id)))
    },
    activeTabList: function () {
      return this.selectedTabs.map((el) => el.name)
    },

    flatTableFilters: function () {
      const tableFilters = this.tableFilters

      const list = Object.keys(this.tableFilters).reduce(function (r, k) {
        return r.concat(tableFilters[k].items);
      }, [])

      return list
    },
  },

  watch: {
    selectedTabs: {
      handler: function (newVal) {
        this.$eventBus.emit('active-tabs-changed', {
          target: this,
          tabs: JSON.parse(JSON.stringify(newVal.map((el) => el.name)))
        })
      },
      deep: true,
    },

    filter: {
      handler: function (newVal) {
        const eventBus = this.$eventBus
        const emitDataFilterChanged = debounce(function (evt) {
          eventBus.emit('data-filter-changed', evt)
        })

        this.tableFilters = {}
        Object.entries(newVal.items).map((el) => {
          const items = el[1].map((e) => {
            const table = this.tabs.filter((te) => {
              if (e.source === te.name) {
                return e
              }
            })[0].label

            return {
              table,
              source: e.key,
              label: e.label
            }
          })

          this.tableFilters[el[0]] = {
            items
          }
        })

        const filterItems = Object.entries(newVal.items).reduce((old, [, items]) => [...old, ...items], [])

        this.filtered.items = Object.entries(this.filtered.items)
          .map(([source, items]) => {
            return {
              [source]: items.filter(
                x => !!filterItems.find(
                  y => (x[y.property] == y.value) && (y.source == source)
                )
              )
            }
          })
          .reduce((acc, el) => Object.assign(acc, el), Object.create(null))

        this.filtered.ids = Object.entries(this.filtered.ids)
          .map(([source, items]) => {
            return {
              [source]: items.filter(
                x => !!filterItems.find(
                  y => (x.value == y.value) && (y.source == source)
                )
              )
            }
          })
          .reduce((acc, el) => Object.assign(acc, el), Object.create(null))

        const newItems = {}
        Object.entries(newVal.items).map((el) => {
          newItems[el[0]] = el[1].map((e) => e.value)
        })

        const newSearches = {}
        Object.entries(newVal.searches).map((el) => {
          newSearches[el[0]] = {
            from: el[1].from,
            to: el[1].to,
            search: el[1].search
          }
        })

        if (this.emitFilterChanged) {
          emitDataFilterChanged({
            target: this,
            filter: {
              searches: newSearches,
              items: newItems
            }
          })
        } else {
          this.emitFilterChanged = true
        }

        if (this.filter.searches && this.filter.searches.constructor === Object && Object.keys(this.filter.searches).length > 0) {
          this.filter.searches = {}
          this.emitFilterChanged = false
        }
      },
      deep: true,
    }
  },
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');

.tab-container {
  padding: 20px;
}

.title {
  font-family: "Host Grotesk", serif;
  font-weight: 400;
  font-size: 20px;
  font-style: normal;
  padding: 15px;
}

.card-table{
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .dynamic-font-size {
    max-width: 90px;
    font-size: 10px;
  }
}

.num-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  font-size: 14px;
  min-width: 40px;
  height: 20px;
  background-color: #e9e9e9;
  border-radius: 8px;
}

.icon-tab {
  font-size: 12px;
  margin-right: 8px;
}

.p-chip.search-chip {
  background: #2196f3;
  color: white;
}

.filter-wrap {
  max-height: 390px;
  overflow-y: scroll;
}

.filter-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background: #e9e9e9 !important;
}

.filter-wrap::-webkit-scrollbar-thumb {
  background: linear-gradient(0deg, #0098f0 70%, #00f2db 100%) !important;
  border-radius: 10px;
}

.filter-wrap::-webkit-scrollbar {
  width: 6px;
}

.p-chip.filter-chip {
  background: #e9e9e9;
  color: rgb(138, 138, 138);
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  margin: 5px;
}

.p-chip.filter-chip i {
  color: var(--primary-color);
}

.p-chip.filter-chip .pi-times-circle:before {
  color: red !important;
}

.wrapper-mindtab {
  position: relative;
}

.clean-filters {
  /* position: fixed;*/
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 6px;
  font-size: 12px;
  text-transform: uppercase;
  width: 140px;
  background-color: rgb(255, 120, 120);
  padding: 6px 12px;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.clean-filters i {
  margin: 0px 6px;
  font-size: 10px;
}

.num-filtri {
  padding: 8px;
  color: #0098f0;
}
</style>
